export const PERMISSION_GROUP_KEY_MAPPING: Record<string, string> = {
  ALL: 'All Permissions',
  BRAND: 'Brand',
  BRAND_ATTACHMENTS: 'Brand Attachments',
  BRAND_LOGS: 'Brand Logs',
  BRAND_MANAGEMENT: 'Brand Management',
  BRAND_PRICELIST: 'Brand Pricelist',
  BRAND_PRICING_AND_SUPPLIERS: 'Brand Pricing and Suppliers',
  CLIENT: 'Client',
  CLIENT_GENERAL: 'Client General',
  CLIENT_LOGS: 'Client Logs',
  CLIENT_MANAGEMENT: 'Client Management',
  CLIENT_PAYMENTS: 'Client Payments',
  CLIENT_SHIPPING: 'Client Shipping',
  COUNTRY: 'Country',
  COUNTRY_LOGS: 'Country Logs',
  COUNTRY_MANAGEMENT: 'Country Management',
  COUNTRY_PRICING: 'Country Pricing',
  COUNTRY_SHIPPING: 'Country Shipping',
  ROLE: 'Role',
  ROLES_PERMISSIONS: 'Role Permissions',
  ROLE_LOGS: 'Role Logs',
  USER: 'User',
  USER_ACCOUNT: 'User Account',
  USER_ATTACHMENT: 'User Attachment',
  USER_LOGS: 'User Logs',
  SUPPLIER: 'Supplier',
  TASK: 'Task',
  TASK_GENERAL: 'Task General',
  TASK_LOGS: 'Task Logs',
  TASK_ATTACHMENTS: 'Task Attachments',
  SUPPLIER_GENERAL: 'Supplier General',
  SUPPLIER_PRICELIST: 'Supplier Pricelist',
  SUPPLIER_SHIPPING: 'Supplier Shipping',
  SUPPLIER_PRICING: 'Supplier Pricing',
  SUPPLIER_MANAGEMENT: 'Supplier Management',
  SUPPLIER_ATTACHMENTS: 'Supplier Attachments',
  SUPPLIER_LOGS: 'Supplier Logs',
  SUPPLIER_COMMUNICATION_HUB: 'Supplier Communication Hub',
  BRAND_COMMUNICATION_HUB: 'Brand Communication Hub',
  CLIENT_COMMUNICATION_HUB: 'Client Communication Hub',
  NOTE: 'Note',
  LEAD: 'Lead',
  LEAD_ASSIGNMENT: 'Lead Assignments',
  LEAD_ATTACHMENTS: 'Lead Attachment',
  LEAD_COMMUNICATION_HUB: 'Lead Communication Hub',
  LEAD_GENERAL: 'Lead General',
  LEAD_LOGS: 'Lead Logs',
  DEAL_COMMUNICATION_HUB: 'Deal Communication Hub',
  DEAL: 'Deal',
  DEAL_PURCHASE_REQUEST: 'Deal Purchase Request',
  DEAL_ATTACHMENTS: 'Deal Attachments',
  DEAL_LOGS: 'Deal Logs',
  DEAL_COMMERCIAL_OFFER: 'Deal Commercial Offer',
  PURCHASE_REQUEST: 'Purchase Request',
  PURCHASE_REQUEST_GENERAL: 'Purchase Request General',
  PURCHASE_REQUEST_SUPPLIER_OFFER: 'Purchase Request Supplier Offer',
  PURCHASE_REQUEST_TASK: 'Purchase Request Task',
  PURCHASE_REQUEST_COMMUNICATION_HUB: 'Purchase Request Communication Hub',
  PURCHASE_REQUEST_ATTACHMENTS: 'Purchase Request Attachments',
  PURCHASE_REQUEST_LOGS: 'Purchase Request Logs',
  ITEM: 'Item',
  ITEM_SUPPLIERS: 'Item Suppliers',
  ITEM_TASK: 'Item Task',
  ITEM_ATTACHMENTS: 'Item Attachments',
  ITEM_LOGS: 'Item Logs',
  BRAND_TASK: 'Brand Task',
  CLIENT_TASK: 'Client Task',
  COUNTRY_TASK: 'Country Task',
  SUPPLIER_TASK: 'Supplier Task',
  LEAD_TASK: 'Lead Task',
  DEAL_TASK: 'Deal Task',
  DASHBOARD: 'Dashboard',
  PURCHASE_ORDER: 'Purchase Order',
  PURCHASE_ORDER_ATTACHMENT: 'Purchase Order Attachment',
  PURCHASE_ORDER_GENERAL: 'Purchase Order General',
  PURCHASE_ORDER_COMMUNICATION_HUB: 'Purchase Order Communication Hub',
  PURCHASE_ORDER_TASK: 'Purchase Order Tasks',
  PURCHASE_ORDER_LOGS: 'Purchase Order Logs',
  PURCHASE_ORDER_SHIPPING_INFORMATION: 'Purchase Order Shipping Information',
  ORDER: 'Order',
  ORDER_ATTACHMENT: 'Order Attachment',
  ORDER_COMMUNICATION_HUB: 'Order Communication Hub',
  ORDER_GENERAL: 'Order General',
  ORDER_LOGS: 'Order Logs',
  ORDER_MANAGEMENT: 'Order Management',
  ORDER_STATUS: 'Order Status',
  ORDER_TASK: 'Order Task',
  BRAND_LOCK: 'Brand Lock',
  COUNTRY_WAREHOUSE: 'Country Warehouse',
};
